
import { iTemplate } from '@/modules/documentExecution/documentDetails/DocumentDetails'
import { defineComponent, PropType } from 'vue'
import { AxiosResponse } from 'axios'
import { iDocument } from '@/modules/documentExecution/documentDetails/DocumentDetails'
import { downloadDirect } from '@/helpers/commons/fileHelper'
import { VCodeMirror } from 'vue3-code-mirror'
import { mapState } from 'vuex'
import { startOlap } from '../../dialogs/olapDesignerDialog/DocumentDetailOlapHelpers'
import mainDescriptor from '@/modules/documentExecution/documentDetails/DocumentDetailsDescriptor.json'
import driversDescriptor from '@/modules/documentExecution/documentDetails/tabs/drivers/DocumentDetailsDriversDescriptor.json'
import historyDescriptor from './DocumentDetailsHistory.json'
import KnListBox from '@/components/UI/KnListBox/KnListBox.vue'
import KnInputFile from '@/components/UI/KnInputFile.vue'
import InlineMessage from 'primevue/inlinemessage'

const crypto = require('crypto')

export default defineComponent({
    name: 'document-drivers',
    components: { KnListBox, KnInputFile, VCodeMirror, InlineMessage },
    props: { selectedDocument: { type: Object as PropType<iDocument>, required: true } },
    computed: {
        showTemplateContent(): any {
            switch (this.selectedTemplateFileType) {
                case 'xml':
                    return true
                case 'xls':
                    return true
                case 'rptdesign':
                    return true
                case 'sbicockpit':
                    return true
                case 'json':
                    return true
                case 'sbigeoreport':
                    return true
                default:
                    return false
            }
        },
        designerButtonVisible(): boolean {
            return this.selectedDocument.typeCode == 'OLAP' || this.selectedDocument.typeCode == 'KPI' || this.selectedDocument.engine == 'knowagegisengine'
        },
        ...mapState({
            user: 'user'
        })
    },
    data() {
        return {
            mainDescriptor,
            driversDescriptor,
            historyDescriptor,
            selectedTemplate: {} as iTemplate,
            listOfTemplates: [] as iTemplate[],
            selectedTemplateFileType: null as any,
            selectedTemplateContent: '' as any,
            loading: false,
            triggerUpload: false,
            uploading: false,
            codeMirrorScriptType: {} as any,
            tst: '',
            scriptOptions: {
                readOnly: true,
                mode: 'text/javascript',
                indentWithTabs: true,
                smartIndent: true,
                lineWrapping: true,
                matchBrackets: true,
                autofocus: true,
                theme: 'eclipse',
                lineNumbers: true
            }
        }
    },
    created() {
        this.getAllTemplates()
        this.setupCodeMirror()
    },
    methods: {
        async getAllTemplates() {
            this.loading = true
            this.$http
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/documentdetails/${this.selectedDocument.id}/templates`)
                .then((response: AxiosResponse<any>) => (this.listOfTemplates = response.data as iTemplate[]))
                .finally(() => (this.loading = false))
        },
        async getSelectedTemplate(templateId) {
            this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/documentdetails/${this.selectedDocument.id}/templates/selected/${templateId}`, { headers: { Accept: 'application/json, text/plain, */*', 'X-Disable-Errors': 'true' } }).then((response: AxiosResponse<any>) => {
                this.selectedTemplateFileType == 'sbicockpit' || this.selectedTemplateFileType == 'json' || this.selectedTemplateFileType == 'sbigeoreport' ? (this.selectedTemplateContent = JSON.stringify(response.data, null, 4)) : (this.selectedTemplateContent = response.data)
            })
        },
        setupCodeMirror() {
            const interval = setInterval(() => {
                if (!this.$refs.codeMirrorScriptType) return
                this.codeMirrorScriptType = (this.$refs.codeMirrorScriptType as any).editor as any
                clearInterval(interval)
            }, 200)
        },
        changeCodemirrorMode() {
            let mode = ''
            switch (this.selectedTemplateFileType) {
                case 'xml':
                    mode = 'text/html'
                    break
                case 'xls':
                    mode = 'text/html'
                    break
                case 'rptdesign':
                    mode = 'text/html'
                    break
                case 'sbicockpit':
                    mode = 'text/javascript'
                    break
                case 'json':
                    mode = 'text/javascript'
                    break
                case 'sbigeoreport':
                    mode = 'text/javascript'
            }
            setTimeout(() => {
                this.setupCodeMirror()
                this.codeMirrorScriptType.setOption('mode', mode)
            }, 250)
        },
        setFileType(template) {
            if (template && template.name) {
                let fileType = template.name.split('.')
                this.selectedTemplateFileType = fileType[fileType.length - 1]
            }
        },
        selectTemplate(event) {
            this.selectedTemplate = event as iTemplate
            this.setFileType(event)
            this.changeCodemirrorMode()
            this.getSelectedTemplate(event.id)
        },
        setUploadType() {
            this.triggerUpload = false
            setTimeout(() => (this.triggerUpload = true), 200)
        },
        startTemplateUpload(event) {
            this.uploading = true
            this.uploadTemplate(event.target.files[0])
            this.triggerUpload = false
            setTimeout(() => (this.uploading = false), 200)
        },
        async uploadTemplate(uploadedFile) {
            var formData = new FormData()
            formData.append('file', uploadedFile)
            await this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/documentdetails/${this.selectedDocument.id}/templates`, formData, { headers: { 'Content-Type': 'multipart/form-data', 'X-Disable-Errors': 'true' } })
                .then(async () => {
                    this.$store.commit('setInfo', { title: this.$t('common.toast.success'), msg: this.$t('common.toast.uploadSuccess') })
                    this.getAllTemplates()
                    this.selectTemplate(this.listOfTemplates[0])
                })
                .catch(() => this.$store.commit('setError', { title: this.$t('common.toast.errorTitle'), msg: this.$t('documentExecution.documentDetails.history.uploadError') }))
                .finally(() => (this.triggerUpload = false))
        },
        setActiveTemplate(template) {
            this.$http
                .put(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/documentdetails/${this.selectedDocument.id}/templates/${template.id}`, { headers: { 'X-Disable-Errors': 'true' } })
                .then(() => {
                    this.$store.commit('setInfo', { title: this.$t('common.toast.success'), msg: this.$t('documentExecution.documentDetails.history.activeOk') })
                    this.getAllTemplates()
                })
                .catch(() => this.$store.commit('setError', { title: this.$t('common.toast.errorTitle'), msg: this.$t('documentExecution.documentDetails.history.activeError') }))
        },
        async downloadTemplate(template) {
            let fileType = template.name.split('.')
            await this.$http
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/documentdetails/${this.selectedDocument.id}/templates/${template.id}/${fileType[fileType.length - 1]}/file`, {
                    headers: { Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9', 'X-Disable-Errors': 'true' }
                })
                .then((response: AxiosResponse<any>) => {
                    if (response.data.errors) {
                        this.$store.commit('setError', { title: this.$t('common.error.downloading'), msg: this.$t('common.error.errorCreatingPackage') })
                    } else {
                        this.$store.commit('setInfo', { title: this.$t('common.toast.success') })
                        if (response.headers) {
                            var contentDisposition = response.headers['content-disposition']
                            var contentDispositionMatcher = contentDisposition.match(/filename[^;\n=]*=((['"]).*?\2|[^;\n]*)/i)
                            if (contentDispositionMatcher && contentDispositionMatcher.length > 1) {
                                var fileAndExtension = contentDispositionMatcher[1]
                                var completeFileName = fileAndExtension.replaceAll('"', '')
                                if (fileType[fileType.length - 1] == 'json' || fileType[fileType.length - 1] == 'sbicockpit') {
                                    downloadDirect(JSON.stringify(response.data), completeFileName, 'text/html; charset=UTF-8')
                                } else {
                                    downloadDirect(response.data, completeFileName, 'text/html; charset=UTF-8')
                                }
                            }
                        }
                    }
                })
                .catch((error) => this.$store.commit('setError', { title: this.$t('common.toast.errorTitle'), msg: error.message }))
        },
        deleteTemplateConfirm(template) {
            this.$confirm.require({
                header: this.$t('common.toast.deleteConfirmTitle'),
                message: this.$t('common.toast.deleteMessage'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.deleteTemplate(template)
            })
        },
        async deleteTemplate(template) {
            await this.$http
                .delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/documentdetails/${this.selectedDocument.id}/templates/${template.id}`, { headers: { Accept: 'application/json, text/plain, */*', 'X-Disable-Errors': 'true' } })
                .then(() => {
                    this.$store.commit('setInfo', { title: this.$t('common.toast.deleteTitle'), msg: this.$t('common.toast.deleteSuccess') })
                    this.getAllTemplates()
                })
                .catch((error) => this.$store.commit('setError', { title: this.$t('common.toast.errorTitle'), msg: error.message }))
        },
        openDesignerConfirm() {
            this.$confirm.require({
                header: this.$t('common.toast.warning'),
                message: this.$t('documentExecution.olap.openDesignerMsg'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    switch (this.selectedDocument.typeCode) {
                        case 'KPI':
                            this.openKpiDocumentDesigner()
                            break
                        case 'MAP': {
                            this.openGis()
                            break
                        }
                        default:
                            this.openDesigner()
                    }
                }
            })
        },
        async openDesigner() {
            if (this.listOfTemplates.length === 0) {
                this.$emit('openDesignerDialog')
            } else {
                const activeTemplate = this.findActiveTemplate()
                const sbiExecutionId = crypto.randomBytes(16).toString('hex')
                await startOlap(this.$http, this.user, sbiExecutionId, this.selectedDocument, activeTemplate, this.$router)
            }
        },
        findActiveTemplate() {
            let activeTemplate = null as any
            for (let i = 0; i < this.listOfTemplates.length; i++) {
                if (this.listOfTemplates[i].active) {
                    activeTemplate = this.listOfTemplates[i]
                    break
                }
            }
            return activeTemplate
        },
        openGis() {
            this.$router.push(`/gis/edit?documentId=${this.selectedDocument.id}`)
        },
        openKpiDocumentDesigner() {
            this.$router.push(`/kpi-edit/${this.selectedDocument.id}?from=documentDetail`)
        }
    }
})
